"use client";

import { Box, Button, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();

  useEffect(() => {
    console.error("Error:", error);
  }, [error]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "space-between",
      }}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 3,
        }}>
        <Typography variant="h1" sx={{ fontSize: "4rem", fontWeight: "bold", mb: 2 }}>
          Oops!
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
          Something went wrong. Please try again later.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.push("/")}
          sx={{ textTransform: "none", fontWeight: "600", px: 4, py: 1.5 }}>
          Go to Homepage
        </Button>
      </Box>
    </Box>
  );
}
